import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  exerciseWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },

  detailBlock: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.divider}`,
  },

  filesWrapper: {
    marginTop: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },

  exerciseHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  ownerWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
}));
